import actions from './actions'
import getters from './getters'
import mutations from './mutations'

const state = {
  Refreshment: {
    currency: '',
    price_per_person: ''
  },
  refreshmentInfo: {},
  Currencies: [],
  Countrys: [],
  refreshmentPrice: [],
  dataBank: [],
  dataInfoBankPax: {}
}

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations
}
